// <s-review-wall> — opens a tapped review screenshot ([data-review-open] > img) large in the wall's
// <dialog data-review-dialog>. Closing uses the native command="close" button inside the dialog.
class SReviewWall extends HTMLElement {
  #ac = null;

  connectedCallback() {
    this.#ac = new AbortController();
    const dialog = this.querySelector('dialog[data-review-dialog]');
    const target = dialog?.querySelector('img[data-review-full]');
    if (!dialog || !target) return;

    for (const button of this.querySelectorAll('[data-review-open]')) {
      button.addEventListener('click', () => {
        const img = button.parentElement?.querySelector('img');
        if (!img) return;
        // Use the widest srcset candidate so the screenshot text stays sharp when enlarged.
        const candidates = (img.srcset || '').split(',').map((c) => c.trim().split(/\s+/)[0]).filter(Boolean);
        target.src = candidates.at(-1) || img.currentSrc || img.src;
        target.alt = img.alt || '';
        // Repeat the card's crop (same object-position) so names and inbox buttons stay hidden when enlarged.
        target.style.objectPosition = getComputedStyle(img).objectPosition;
        dialog.showModal();
      }, { signal: this.#ac.signal });
    }

    // Arrow buttons (command="--prev" / "--next") scroll the track by one visible page.
    const track = this.querySelector('[data-review-track]');
    const prev = this.querySelector('[data-review-prev]');
    const next = this.querySelector('[data-review-next]');
    const updateArrows = () => {
      if (!track) return;
      const max = track.scrollWidth - track.clientWidth - 2;
      const pos = Math.abs(track.scrollLeft);
      if (prev) prev.disabled = pos <= 2;
      if (next) next.disabled = pos >= max;
    };
    this.addEventListener('command', (event) => {
      if (!track || (event.command !== '--prev' && event.command !== '--next')) return;
      const rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      const step = track.clientWidth * (event.command === '--next' ? 1 : -1) * rtl;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: step, behavior: reduced ? 'auto' : 'smooth' });
    }, { signal: this.#ac.signal });
    track?.addEventListener('scroll', updateArrows, { passive: true, signal: this.#ac.signal });
    window.addEventListener('resize', updateArrows, { signal: this.#ac.signal });
    updateArrows();

    // Tap on the dim backdrop closes the dialog.
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-review-wall')) customElements.define('s-review-wall', SReviewWall);
